
// SVG Icon: pause
export default { id: "terriajs-pause" };
export const id = "terriajs-pause";
export const name = "pause";
